import React from 'react';
import {
  Result, Button,
} from 'antd';

const MiniBannerForm = ({ form }) => (
  <Result
    status="success"
    title="Mini Banner Form"
    subTitle="Loren Ipsum"
    extra={[
      <Button type="primary" key="console">
        Go Console
      </Button>,
      <Button key="buy">Buy Again</Button>,
    ]}
  />
);

export default MiniBannerForm;
